import { render, staticRenderFns } from "./MailingListSignup.vue?vue&type=template&id=53c49a68&scoped=true&"
import script from "./MailingListSignup.vue?vue&type=script&lang=js&"
export * from "./MailingListSignup.vue?vue&type=script&lang=js&"
import style0 from "./MailingListSignup.vue?vue&type=style&index=0&id=53c49a68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c49a68",
  null
  
)

export default component.exports